import { createStore } from 'vuex'

export const dataHome = createStore({
  state: () => {
    return {}
  },
  mutations: {}
})
